import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { CustomerAndCompany } from '../../customer/CustomerAndCompany'

@InputType()
export class UpdateCompanyParentArgs extends ActionArgs {
  @Field(() => ID)
  companyId: string

  @Field(() => ID, { nullable: true })
  parentCompanyId?: string

  @Field({ nullable: true })
  parentCompanyName?: string
}

export interface IUpdateCompanyParent extends IAction<CustomerAndCompany, UpdateCompanyParentArgs> {}
